module.exports = "<mat-progress-bar *ngIf=\"isLoading\" mode=\"query\"></mat-progress-bar>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/loader/query-loader/query-loader.component.html
// module id = ../../../../../src/app/directive/loader/query-loader/query-loader.component.html
// module chunks = main